import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const PastEvents: React.FC = () => {
	const events = [
		{
			id: "typescript-2024-03",
			title: "実践TypeScript",
			date: "2024年3月16日",
			description: "型システムの理解と実践的な使い方",
			participants: 18,
			materials: true,
			recording: true,
			tags: ["TypeScript", "フロントエンド"],
		},
		{
			id: "docker-2024-02",
			title: "Docker入門",
			date: "2024年2月24日",
			description: "Dockerの基本概念とコンテナ化の実践",
			participants: 25,
			materials: true,
			recording: true,
			tags: ["Docker", "インフラ"],
		},
		{
			id: "git-2024-01",
			title: "Git/GitHub実践",
			date: "2024年1月20日",
			description: "チーム開発のためのGit/GitHub活用法",
			participants: 20,
			materials: true,
			recording: false,
			tags: ["Git", "GitHub", "チーム開発"],
		},
	];

	return (
		<section className="py-16">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-8">過去の勉強会</h2>
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
					{events.map((event) => (
						<Card key={event.id}>
							<CardHeader>
								<CardTitle>{event.title}</CardTitle>
								<CardDescription>{event.date}</CardDescription>
							</CardHeader>
							<CardContent>
								<p className="mb-4">{event.description}</p>
								<div className="space-y-4">
									<div className="flex items-center gap-2">
										<Badge variant="outline">
											参加者: {event.participants}名
										</Badge>
										{event.materials && (
											<Badge variant="secondary">資料あり</Badge>
										)}
										{event.recording && (
											<Badge variant="secondary">録画あり</Badge>
										)}
									</div>
									<div className="flex flex-wrap gap-2">
										{event.tags.map((tag) => (
											<Badge key={tag} variant="outline">
												{tag}
											</Badge>
										))}
									</div>
								</div>
								<Button asChild className="w-full mt-4" variant="outline">
									<Link to={`/study-groups/archive/${event.id}`}>
										詳細を見る
									</Link>
								</Button>
							</CardContent>
						</Card>
					))}
				</div>
				<div className="text-center mt-8">
					<Button asChild variant="outline">
						<Link to="/study-groups/archive">すべての過去の勉強会を見る</Link>
					</Button>
				</div>
			</div>
		</section>
	);
};

export default PastEvents;
